import { useContext, useCallback } from 'react'
import PCLNAnalytics from '@pcln/analytics'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { BaseSetiResponseEvent, SETIResponseEvent } from '@/types'
import useRouteInfo from './useRouteInfo'

function isSuccessfulSetiResponse(
  fullSeti: BaseSetiResponseEvent[]
): fullSeti is SETIResponseEvent[] {
  return (
    fullSeti.length === 0 ||
    ((fullSeti[0] as SETIResponseEvent).setiID !== undefined &&
      (fullSeti[0] as SETIResponseEvent).setiVariantID !== undefined)
  )
}

export default function useGA4AnalyticsForSETI(experimentCode: string) {
  const { fullSETI } = useContext(BootstrapDataContext)
  const routeInfo = useRouteInfo()

  const logGA4Event = useCallback(() => {
    let baseSETI
    if (isSuccessfulSetiResponse(fullSETI))
      baseSETI = fullSETI.find(seti => seti.setiTagName === experimentCode)

    if (!baseSETI?.setiID) return

    PCLNAnalytics.GA4Enabled = true
    PCLNAnalytics.logEvent({
      event: 'seti',
      attributes: {
        seti_id: baseSETI.setiID,
        seti_variant_id: baseSETI.setiVariantID,
        seti_name: experimentCode,
        page_name: routeInfo.pageName,
        product_name: routeInfo.productName
      }
    })
    PCLNAnalytics.GA4Enabled = false
  }, [experimentCode, fullSETI, routeInfo])

  return { logGA4Event }
}
